
import { Component, Vue, Watch } from 'vue-property-decorator'
import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import CreateCustomBill from '@/components/admin/registrations/CreateCustomBill.vue'
import ExportOrderCsv from '@/components/admin/registrations/ExportOrderCsv.vue'
import EditCustomerRegisterModal from '@/components/admin/registrations/EditCustomerRegisterModal.vue'
import { CustomerRegister } from '@/lib/models/CustomerRegister'
import { RallyRound } from '@/lib/models/RallyRound'
import { Rally } from '@/lib/models/Rally'
import { Order } from '@/lib/models/Order'
import sanitizeHtml from 'sanitize-html'
import { Http } from '@/lib/utils/Http'
import UIkit from 'uikit'
import { Customer } from '../../lib/models/Customer'

@Component({
  components: {
    BacLoggedInHeader,
    BacInput,
    BacButton,
    BacModal,
    CreateCustomBill,
    ExportOrderCsv,
    EditCustomerRegisterModal
  }
})
export default class Registration extends Vue {
  CustomerRegister = CustomerRegister

  rallies: Rally[] = []
  rallyRounds: RallyRound[] = []

  search = ''
  rallyFilter = -1
  rallyRoundFilter = -1
  statusFilter = -1

  selectedCustomerRegister = -1
  credit = 0
  currentSelectedState = 0

  loadingItems = false
  actionLoading = false

  headers = [
    { text: 'ID', value: 'id', width: '1%' },
    { text: 'E-Mail', value: 'email', width: '1%' },
    { text: 'Name', value: 'name', width: '5%' },
    // { text: 'Teamleader', value: 'parent', width: '10%' },
    // { text: 'Rally', value: 'rallyName', width: '1%' },
    // { text: 'Runde', value: 'rallyRoundName', width: '10%' },
    // { text: 'Type', value: 'teamTypeName', width: '1%' },
    // { text: 'Teamgröße', value: 'teamSize', width: '3%' },
    { text: 'Preis', value: 'price', width: '3%' },
    // { text: 'Verschieben', value: 'move', width: '10%' },
    { text: 'Gutschrift €', value: 'credit', width: '2%' },
    { text: 'Aktionen', value: 'actions', width: '10%' }
  ]

  customerRegisters: CustomerRegister[] = []

  get filteredRallyRounds () {
    if (this.rallyFilter === -1) {
      return this.rallyRounds
    }
    return this.rallyRounds.filter(round => {
      return round.rallyId === this.rallyFilter
    })
  }

  get sortedItems () {
    let sortedItems = this.customerRegisters.sort((a: any, b: any) => {
      /* return a.customerRegisterParentId || a.id - b.customerRegisterParentId || b.id */ return (b as any).id - (a as any).id
    })
    sortedItems = sortedItems.filter(item => {
      if (item.customerRegisterParentId) {
        const parentItem = sortedItems.find(customerRegister => {
          return customerRegister.id === item.customerRegisterParentId
        })
        if (parentItem) {
          if (!parentItem.members.find(findItem => item.id === findItem.id)) {
            parentItem.members.push(item)
          }
        }
      }
      return item.customerRegisterParentId === 0
    })
    return sortedItems
  }

  get items () {
    return this.customerRegisters.map(customerRegister => {
      if (customerRegister.customerRegisterParentId === 0) {
        const rally = this.rallies.find(rally => rally.id === customerRegister.rallyId)
        if (rally) {
          customerRegister.rally = rally
        }

        const rallyRound = this.rallyRounds.find(rallyRound => rallyRound.id === customerRegister.rallyRoundId)
        if (rallyRound) {
          customerRegister.rallyRound = rallyRound
        }
        return customerRegister
      }
    })
    // const customerRegisterGroupedByParent: any[] = []
    /* this.customerRegisters.forEach(customerRegister => {
      const parentId = customerRegister.customerRegisterParentId || customerRegister.id
      if (parentId) {
        if (customerRegisterGroupedByParent[parentId].length) {
          customerRegisterGroupedByParent[parentId].push(customerRegister)
        } else {
          customerRegisterGroupedByParent[parentId] = [customerRegister]
        }
      }
    }) */

    /* this.customerRegisters.map(customerRegister => {
      // add grouping
      if (customerRegister.teamlead) {
        (customerRegister as any).Team = JSON.stringify({
          parentId: customerRegister.customerRegisterParentId,
          parentName: `${customerRegister.teamlead.firstname} ${customerRegister.teamlead.lastname}`,
          rallyName: this.rallies.find(rally => rally.id === customerRegister.teamlead?.rallyId)?.name,
          rallyRoundName: this.rallyRounds.find(rallyRound => rallyRound.id === customerRegister.teamlead?.rallyRoundId)?.name,
          teamTypeName: (customerRegister as any).teamTypeName,
          teamSize: customerRegister.teamlead.teamSize,
          status: customerRegister.teamlead.status,
          hasUnpaidMembers: customerRegister.teamlead.hasUnpaidMembers
        })
        // (customerRegister as any).Team = `${customerRegister.customerRegisterParentId} ${customerRegister.teamlead.firstname} ${customerRegister.teamlead.lastname}`
      } else {
        (customerRegister as any).Team = JSON.stringify({
          parentId: customerRegister.id,
          parentName: `${customerRegister.firstname} ${customerRegister.lastname}`,
          rallyName: this.rallies.find(rally => rally.id === customerRegister.rallyId)?.name,
          rallyRoundName: this.rallyRounds.find(rallyRound => rallyRound.id === customerRegister.rallyRoundId)?.name,
          teamTypeName: (customerRegister as any).teamTypeName,
          teamSize: customerRegister.teamSize,
          status: customerRegister.status,
          hasUnpaidMembers: customerRegister.hasUnpaidMembers
        })
        // (customerRegister as any).Team = `${customerRegister.id} ${customerRegister.firstname} ${customerRegister.lastname}`
      }
    })

    this.customerRegisters = this.customerRegisters.sort((a, b) => {
      return (a as any).parentId - (b as any).parentId
    })
    console.log(this.customerRegisters)
    */
  }

  mounted () {
    window.location.href= '/app'
    this.loadCustomerRegisters()
    this.loadRallies()
    this.loadRallyRounds()
    this.registerEndlessScrollingTable()
  }

  async registerEndlessScrollingTable () {
    window.onscroll = () => {
      const body = document.body
      const html = document.documentElement

      const totalPageHeight = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight)
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= totalPageHeight - 2000 // 2000 px before readching bottom load more
      if (bottomOfWindow) {
        if (!this.loadingItems) {
          this.loadingItems = true

          this.loadCustomerRegisters(true)
        }
      }
    }
  }

  async loadRallies () {
    this.rallies = await Rally.getAll({})
  }

  async loadRallyRounds () {
    this.rallyRounds = await RallyRound.getAll({})
  }

  async loadCustomerRegisters (pushToExisting = false) {
    const newCustomerRegisters = await CustomerRegister.getAll({
      params: ['search', this.search || ' ', this.rallyFilter, this.rallyRoundFilter, this.statusFilter, pushToExisting ? this.customerRegisters.length : 0],
      subclasses: [
        { subclassInstance: RallyRound, subclassPath: 'rallyRound' },
        { subclassInstance: Rally, subclassPath: 'rally' },
        { subclassInstance: CustomerRegister, subclassPath: 'teamlead' },
        { subclassInstance: Order, subclassPath: 'orders' }
      ]
    })
    this.loadingItems = false

    if (pushToExisting) {
      newCustomerRegisters.forEach((customerRegister: CustomerRegister) => {
        if (!this.customerRegisters.find(findCustomerRegister => {
          return customerRegister.id === findCustomerRegister.id
        })) {
          this.customerRegisters.push(customerRegister)
        }
      })
    } else {
      this.customerRegisters = newCustomerRegisters
    }

    this.customerRegisters.map(customerRegister => {
      if (customerRegister.rallyRound) {
        (customerRegister as any).rallyRoundName = customerRegister.rallyRound.name
      }
      if (customerRegister.rally) {
        (customerRegister as any).rallyName = customerRegister.rally.name;
        (customerRegister as any).teamTypeName = customerRegister.getVehicleName(customerRegister.rally)
        if (!(customerRegister as any).teamTypeName && customerRegister.teamlead) {
          (customerRegister as any).teamTypeName = (customerRegister as any).teamlead.getVehicleName(customerRegister.rally)
        }
      }
      (customerRegister as any).name = `${customerRegister.firstname} ${customerRegister.lastname}`
    })
  }

  viewBill (id: number) {
    window.location.replace(`/api/order/pdf/${id}`)
  }

  async saveCredit (id: number) {
    if (this.actionLoading) {
      return false
    }
    this.actionLoading = true
    await Http.request('/api/order/credit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ customerRegisterId: id, price: this.credit })
    })
    await this.loadCustomerRegisters()
    UIkit.notification({
      message: 'Gutschrift gespeichert!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
    this.actionLoading = false
  }

  async changeStatus (e: Event, item: any) {
    const newState = parseInt((e.target as any).value)
    const oldState = item.status
    const res = await Http.request(`/api/customer-register/change-status/${item.id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ newState, oldState })
    })
    let notificationText = ''
    if (res.status === 200) {
      notificationText = 'Status gespeichert!'
    } else {
      notificationText = 'Es ist ein unbekannter Fehler aufgetreten! Bitte kontaktiere den Entwickler!'
    }
    UIkit.notification({
      message: notificationText,
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }

  async sendPaymentReminder (id: number) {
    if (this.actionLoading) {
      return
    }
    this.actionLoading = true
    await Http.request(`/api/customer-register/send-payment-reminder/${id}/gehw873h1`)
    UIkit.notification({
      message: 'Zahlungserinnerung gesendet!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
    this.actionLoading = false
  }

  async sendMail (id: number) {
    if (this.actionLoading) {
      return
    }
    this.actionLoading = true
    await Http.request('/api/customer-register/send-register-confirmation-mail/gehw873h1', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ customerRegisterId: id })
    })

    UIkit.notification({
      message: 'Mail gesendet!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
    this.actionLoading = false
  }

  async createBill (id: number) {
    if (this.actionLoading) {
      return
    }
    this.actionLoading = true
    await Http.request('/api/order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ customerRegisterId: id })
    })
    await this.loadCustomerRegisters()
    this.actionLoading = false
  }

  searchTimeout = 0;
  @Watch('search')
  onSearchChanged () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(this.loadCustomerRegisters, 500)
  }

  @Watch('rallyRoundFilter')
  onRallyRoundFilterChanged () {
    this.loadCustomerRegisters()
  }

  @Watch('rallyFilter')
  onRallyFilterChanged () {
    this.loadCustomerRegisters()
  }

  @Watch('statusFilter')
  onStatusFilterChanged () {
    this.loadCustomerRegisters()
  }
}
